import { gql } from '@apollo/client'
import { WORKER_ONBOARDING_PART_FRAGMENT } from '../apollo.fragment'

export const UPDATE_WORKER_ONBOARDING_PART_MUTATION = gql`
	mutation updateWorkerOnboardingPart($id: String!, $integrationAttributes: JSON!) {
		updateWorkerOnboardingPart(id: $id, integrationAttributes: $integrationAttributes) {
			...workerOnboardingPartFragment
		}
	}

	${WORKER_ONBOARDING_PART_FRAGMENT}
`
